// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"18acf350","382":"b1930e96","600":"3d8c5288","918":"5ca11663"}[chunkId] + ".chunk.js";
};